import React, { Component } from "react";
import axios from "axios";
import PanelHeader from "../../components/PanelHeader/PanelHeader";
import { Card, CardBody, Col, CardHeader, Row } from "reactstrap";
import {
  GoogleMap,
  Marker,
  InfoWindow,
  withGoogleMap,
  withScriptjs,
} from "react-google-maps";
import { Button, Tag, Space, DatePicker } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import blueMarker from "../../assets/img/mapMarker/blue_map_marker.png";
import redMarker from "../../assets/img/mapMarker/red_map_marker.png";
import yellowMarker from "../../assets/img/mapMarker/yellow_map_marker.png";
import greenMarker from "../../assets/img/mapMarker/green_map_marker.png";
import dayjs from "dayjs";

class MyMapComponent extends Component {
  render() {
    return (
      <GoogleMap
        defaultZoom={12}
        defaultCenter={{ lat: 39.59242621528501, lng: -0.45891777479907003 }}
        mapTypeId={"satellite"}
        options={{
          disableDefaultUI: true,
          zoomControl: false,
          streetViewControl: false,
          mapTypeControl: true,
          fullscreenControl: false,
          gestureHandling: "greedy",
          styles: [
            {
              featureType: "poi",
              elementType: "labels",
              stylers: [{ visibility: "off" }],
            },
            {
              featureType: "road",
              elementType: "labels",
              stylers: [{ visibility: "off" }], // Oculta las etiquetas de carreteras
            },
          ],
        }}
      >
        {this.props.markers.map((marker, index) => (
          <Marker
            key={index}
            position={{ lat: marker.lat, lng: marker.lng }}
            onClick={() => this.props.handleOpenMarker(index)}
            icon={{
              url: marker.statusIcon,
              scaledSize: new window.google.maps.Size(40, 40),
            }}
          >
            {marker.showInfo && (
              <InfoWindow
                onCloseClick={() => this.props.handleOpenMarker(index)}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "start",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: 8,
                      padding: "16px 20px",
                    }}
                  >
                    <h6 style={{ margin: 0 }}>{marker.title}</h6>
                    <div style={{ display: "flex", gap: 8 }}>
                      <Tag color={marker.visit_status.statusColor}>
                        {marker.visit_status.name}
                      </Tag>
                      {marker.finish_reason && (
                        <Tag color={marker.finish_reason.finishColor}>
                          {marker.finish_reason.name}
                        </Tag>
                      )}
                    </div>
                  </div>
                  <p
                    style={{
                      width: "90%",
                    }}
                  >
                    {marker.visit_type}
                  </p>
                  <p
                    style={{
                      width: "90%",
                    }}
                  >{`${marker.visit_address}, ${marker.visit_locality}`}</p>
                  <div
                    style={{
                      width: "90%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "start",
                      gap: 8,
                    }}
                  >
                    <span
                      dangerouslySetInnerHTML={{
                        __html: marker.visit_date_day,
                      }}
                    ></span>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: marker.visit_date_hour,
                      }}
                    ></span>
                  </div>
                  <div style={{ padding: "8px 0px" }}>
                    {marker.technician.map((technician) => (
                      <Tag bordered={false} color="purple">
                        {technician.username}
                      </Tag>
                    ))}
                  </div>

                  <Button
                    type="link"
                    onClick={() => this.props.handleRedirect(marker.id)}
                    style={{ paddingTop: 8 }}
                  >
                    Ir al detalle
                  </Button>
                </div>
              </InfoWindow>
            )}
          </Marker>
        ))}
      </GoogleMap>
    );
  }
}
const WrappedMapComponent = withScriptjs(withGoogleMap(MyMapComponent));

class MapView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      visitsList: [],
    };
    this.handleRedirect = this.handleRedirect.bind(this);
  }
  async componentDidMount() {
    this.setState({ loading: true });
    const startDate = dayjs();
    const endDate = dayjs();
    await this.handleGetVisits(startDate, endDate);
    this.setState(
      {
        startDate: startDate,
        endDate: endDate,
      },
      () => this.setState({ loading: false })
    );
  }
  async handleGetVisits(startDate, endDate) {
    try {
      this.setState({ loading: true });
      const startDay = dayjs(startDate).format("YYYY-MM-DD");
      const endDay = dayjs(endDate).format("YYYY-MM-DD");
      const result = await axios.get(
        `https://oficina.nadunet.es/api/rest/get-lista-visitas-domicilio?args[0]=${startDay}--${endDay}`
      );

      const allVisits = result.data.map((visit) => {
        let statusColor = "default";
        let statusIcon = blueMarker;
        switch (parseInt(visit.visit_status.tid)) {
          case 249:
            statusColor = "success";
            statusIcon = greenMarker;
            break;
          case 248:
            statusColor = "processing";
            statusIcon = blueMarker;
            break;
          case 247:
            statusColor = "warning";
            statusIcon = yellowMarker;
            break;
          case 250:
            statusColor = "error";
            statusIcon = redMarker;
            break;
          default:
            break;
        }
        let finishColor = "default";
        switch (parseInt(visit.finish_reason.tid)) {
          case 257:
            finishColor = "success";
            break;
          case 261:
            finishColor = "processing";
            break;
          case 260:
            finishColor = "warning";
            break;
          case 259:
            finishColor = "warning";
            break;
          case 258:
            finishColor = "error";
            break;
          default:
            break;
        }

        return {
          id: visit.id,
          title: visit.title,
          visit_type: visit.visit_type_name,
          visit_status: {
            statusColor: statusColor,
            name: visit.visit_status_name,
          },
          finish_reason: !Array.isArray(visit.finish_reason)
            ? {
                finishColor: finishColor,
                name: visit.finish_reason_name,
              }
            : null,
          visit_address: visit.visit_address,
          visit_locality: visit.visit_locality,
          visit_date_day: visit.visit_date_day,
          visit_date_hour: visit.visit_date_hour,
          technician: [
            ...JSON.parse(visit.assigned_technician),
            ...JSON.parse(visit.working_technician),
          ],
          lat: parseFloat(visit.lat),
          lng: parseFloat(visit.lng),
          statusIcon: statusIcon,
          showInfo: false,
        };
      });
      this.setState({ visitsList: allVisits }, () =>
        this.setState({ loading: false })
      );
    } catch (error) {
      console.log(error);
    }
  }
  handleOpenMarker = (index) => {
    const { visitsList } = this.state;

    const updatedVisitsList = visitsList.map((visit, i) => {
      if (i === index) {
        return { ...visit, showInfo: true };
      } else {
        return { ...visit, showInfo: false };
      }
    });

    this.setState({ visitsList: updatedVisitsList });
  };
  handleRedirect(idx) {
    this.props.history.push(`/citas/${idx}`);
  }

  render() {
    return (
      <div>
        <PanelHeader size="sm" />
        <div className="content">
          <Row>
            <Col xs={12}>
              <Card>
                <CardHeader
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <h5>Mapa de Citas</h5>
                  <Space>
                    {this.state.startDate && this.state.endDate && (
                      <DatePicker.RangePicker
                        defaultValue={[
                          this.state.startDate,
                          this.state.endDate,
                        ]}
                        format={"DD/MM/YYYY"}
                        onChange={(props) => {
                          const [startDate, endDate] = props;
                          this.handleGetVisits(startDate, endDate);
                        }}
                        allowClear={false}
                      />
                    )}
                  </Space>
                </CardHeader>
                <CardBody>
                  {this.state.loading ? (
                    <Space
                      style={{
                        minHeight: "70vh",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <LoadingOutlined style={{ fontSize: "28px" }} />
                    </Space>
                  ) : (
                    <WrappedMapComponent
                      googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBqHety4jjWm2r747ZT8L-pUDDQqCLY05o&v=3.exp&libraries=geometry,drawing,places"
                      loadingElement={<div style={{ height: `100%` }} />}
                      containerElement={<div style={{ height: `560px` }} />}
                      mapElement={<div style={{ height: `100%` }} />}
                      markers={this.state.visitsList}
                      handleOpenMarker={this.handleOpenMarker}
                      handleRedirect={this.handleRedirect}
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default MapView;



// WEBPACK FOOTER //
// ./src/views/HomeVisits/MapView.jsx